import axios from 'axios';

const API_KEY = 'cc7189799452f5dde2148d18ecf87bc7'; // OpenWeatherMap API key
const BASE_URL = 'https://api.openweathermap.org/data/2.5';

/**
 * Fetches current weather data for a given city
 * @param {string} city - The city name to search for
 * @returns {Promise} Weather data from OpenWeatherMap API
 */
export const getCurrentWeather = async (city) => {
  try {
    const response = await axios.get(`${BASE_URL}/weather`, {
      params: {
        q: city,
        appid: API_KEY,
        units: 'metric' // Use metric units (Celsius)
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      throw new Error(error.response.data.message || 'City not found');
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error('No response from weather service');
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error('Error fetching weather data');
    }
  }
};

/**
 * Gets the icon URL for a weather condition
 * @param {string} iconCode - The icon code from OpenWeatherMap API
 * @returns {string} Full URL to the weather icon
 */
export const getWeatherIconUrl = (iconCode) => {
  return `http://openweathermap.org/img/wn/${iconCode}@2x.png`;
};

/**
 * Fetches 5-day weather forecast for a given city
 * @param {string} city - The city name to search for
 * @returns {Promise} Forecast data from OpenWeatherMap API
 */
export const getWeatherForecast = async (city) => {
  try {
    const response = await axios.get(`${BASE_URL}/forecast`, {
      params: {
        q: city,
        appid: API_KEY,
        units: 'metric'
      }
    });
    return response.data;
  } catch (error) {
    throw new Error('Error fetching forecast data');
  }
};
